<template>
  <div>
    <div class="mt-3">
      <v-card>
        <v-card-title class="title">Envoyer un message</v-card-title>
        <v-card-text>
          <v-layout row class="align-end justify-space-between" wrap>
            <v-flex xs12>
              <v-textarea
                label="Message"
                rows="3"
                v-model="message"
                hide-details
                box
              ></v-textarea>
            </v-flex>
            <v-flex class="ml-2">
              <v-btn icon @click="sendMessage" :loading="loading">
                <v-icon style="cursor: pointer">send</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <div
        class="notice mt-4"
        style="text-align: center"
        v-if="comments.length === 0"
      >
        Pas de message pour l'instant
      </div>
      <div class="d-flex justify-center" v-if="notifsCount > 0">
        <v-btn color="primary" @click="markNotifsAsRead"
          ><v-icon class="mr-2">check</v-icon>Marquer comme lu</v-btn
        >
      </div>

      <div
        v-for="com in comments"
        :key="com._id"
        :class="{
          'ml-5': com.owner === 'user',
          'mr-5': com.owner === 'hil',
          'mr-2': true,
          'pb-2': true
        }"
      >
        <!-- Prettier rule: https://prettier.io/blog/2018/11/07/1.15.0.html#whitespace-sensitive-formatting -->
        <!-- display: inline -->
        <div
          class="message-content px-2 py-2 mt-3"
          :style="`border: 2px solid ${color(com)};`"
          >{{ com.content }}</div
        >
        <div class="message-infos d-flex justify-content-between">
          <div>{{ com.author }}</div>
          <div>{{ com.createdAt | fullDate }}</div>
        </div>
      </div>
    </div>
    <v-snackbar v-model="showError"> Une erreur a eu lieu </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { fetchHil } from "../../utils";
export default {
  props: ["id", "extraAttributes", "active"],
  data() {
    return {
      message: "",
      showError: false,
      loading: false
    };
  },
  created() {},
  timers: {
    reloadAndMarkNotifsAsRead: { time: 10000, autostart: true, repeat: true }
  },
  methods: {
    async sendMessage() {
      if (!this.message) {
        return;
      }
      this.loading = true;
      try {
        const resp = await fetchHil(`/comments/for/${this.id}`, {
          method: "POST",
          body: {
            content: this.message,
            ...this.extraAttributes
          }
        });
        if (!resp.ok) {
          this.showError = true;
        }
        this.message = "";
        this.$store.dispatch("fetchProjectComments", {
          id: this.id
        });
      } catch (e) {
        console.error(e);
        this.showError = true;
      }
      this.loading = false;
    },
    color(comm) {
      switch (comm.owner) {
        case "hil":
          return "#60A694";
        case "user":
          return "#FF7C5D";
        default:
          return "#DDD";
      }
    },
    async reloadAndMarkNotifsAsRead() {
      if (this.active) {
        await this.$store.dispatch("fetchProjectComments", { id: this.id });
      }
    },
    markNotifsAsRead() {
      this.$store.dispatch("markNotifsAsRead", { projectId: this.id });
    }
  },
  computed: {
    notifsCount() {
      return this.$store.state.notifications.filter(
        ({ idEstate, idProject, seen }) =>
          idEstate == null && idProject === this.id && !seen
      ).length;
    },
    comments() {
      return this.$store.state.currentProjectComments.sort((a, b) => {
        return moment(a.createdAt).isAfter(b.createdAt) ? -1 : 1;
      });
    }
  }
};
</script>

<style>
.message-content {
  font-size: 13px;
  overflow-wrap: break-word;
}
.message-infos {
  padding-left: 8px;
  font-size: 10px;
  font-style: italic;
}
</style>
